<!-- 车皮到达预报 -->
<template>
  <div class="nx-list-page">
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="primary" size="small" plain icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>
    </avue-crud>
    <dialog-reset slotShow height="65vh" top="5vh" width="80%" :title="formTitle" :visible.sync="formVisible">
      <form-component ref="formComponen" :transmitData="transmitData" @handleClose="handleClose"></form-component>
    </dialog-reset>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, exportExcel } from "./api";
import { searchTimeConfig, transitionTitle } from "@/basic-common/util/common";
import { downloadXls } from '@/util/util'
import FormComponent from './components/form-component.vue'

export default {
  mixins: [crudMixins],
  components: { FormComponent },
  data () {
    return {
      apiConfig: { getList, remove: () => Promise.resolve() },
      exportLoading: false,
      defaultParams: {
        arrivalStatus: "0",
      },
      formVisible: false,
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        viewBtn: true,
        delBtn: false,
        column: [
          {
            label: '客户',
            prop: 'custNo',
            type: 'select',
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            search: true, // 查询是否显示
            props: {
              label: 'deptName',
              value: 'id'
            },
          },
          {
            label: '车次编号',
            prop: 'trainNumber',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 150,
            maxlength: 30,
            showWordLimit: true,
          },
          {
            label: '车厢数',
            prop: 'carriageCount',
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'number',
            min: 1,
            max: 99999,
          },
          {
            label: '总重量(吨)',
            prop: 'totalWeight',
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'number',
            precision: 2,
            min: 0.01,
            max: 99999,
          },
          {
            label: '合同名称',
            prop: 'contractName',
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/transport-contract/select/distinct/pycode?contractName={{key}}',
            props: {
              label: 'contractName',
              value: 'id'
            },
          },
          {
            label: '是否到达',
            prop: 'arrivalStatus',
            overHidden: true, // 表格超出隐藏
            type: 'select',
            dataType: 'string',
            dicData: this.$store.getters.commonDict['arrival_status'],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '到达时间',
            prop: 'trainArrivalTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true, // 表格超出隐藏
            width: 150,
          },
          {
            label: '发车时间',
            prop: 'trainDepartTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true, // 表格超出隐藏
            width: 150,
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
    }
  },
  methods: {
    beforeOpen (done, type) {
      // 1.传递交互参数 type id  操作api
      this.transmitData = {
        type,
        id: this.form.id || null,
      }
      this.formTitle = transitionTitle(type)
      this.formVisible = true
    },
    handleClose (type) {
      this.formVisible = false
      // 保存并关闭后刷新列表
      if (type) {
        this.onLoad(this.page, this.query)
      }
    },
    async handleExport () {
      if ((this.page.total || 0) < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `到货通知_${Date.now()}.xlsx`)
        if (this.page.total > 10000) {
          this.$message.warning(`仅导出前 10000 条，共 ${this.page.total} 条`)
        } else {
          this.$message.success('导出成功')
        }
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
